import { computed, Injectable, signal } from '@angular/core';
import { PaginationResponse } from '@iq-central-front-end/share';

export interface DesignationState {
    designations: any[] | null;
    designation: any | null;
    loading: boolean;
    error: string | null;
}

@Injectable({ providedIn: 'root' })
export class DesignationStore {
    private readonly state = signal<DesignationState>({
        designations: null,
        designation: null,
        loading: false,
        error: null,
    });

    readonly designations$ = computed(() => this.state().designations);
    readonly designation$ = computed(() => this.state().designation);
    readonly loading$ = computed(() => this.state().loading);
    readonly error$ = computed(() => this.state().error);

    setLoading(loading: boolean): void {
        this.state.update((state) => ({ ...state, loading }));
    }

    setError(error: string | null): void {
        this.state.update((state) => ({ ...state, error }));
    }

    setDesignations(designations: any[]): void {
        this.state.update((state) => ({ ...state, designations, loading: false }));
    }

    setDesignation(designation: any): void {
        this.state.update((state) => ({
            ...state,
            designation,
            loading: false,
        }));
    }

    addDesignation(designation: any): void {
        this.state.update((state) => ({
            ...state,
            designations: state.designations ? [...state.designations, designation] : [designation],
            loading: false,
        }));
    }

    updateDesignation(updatedDesignation: any): void {
        this.state.update((state) => ({
            ...state,
            designations: state.designations?.map(desig =>
                desig.id === updatedDesignation.id ? updatedDesignation : desig
            ) || null,
            designation: state.designation?.id === updatedDesignation.id ? updatedDesignation : state.designation,
            loading: false,
        }));
    }

    deleteDesignation(designationId: string): void {
        this.state.update((state) => ({
            ...state,
            designations: state.designations?.filter(desig => desig.id !== designationId) || null,
            designation: state.designation?.id === designationId ? null : state.designation,
            loading: false,
        }));
    }

    clearError(): void {
        this.state.update((state) => ({ ...state, error: null }));
    }

    reset(): void {
        this.state.set({
            designations: null,
            designation: null,
            loading: false,
            error: null,
        });
    }
} 